export enum AccessRoleType {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_MANAGER = "ROLE_MANAGER",
  ROLE_HR = "ROLE_HR",
  ROLE_CONTRACTOR = "ROLE_CONTRACTOR",
  ROLE_HIRING_MANAGER = "ROLE_HIRING_MANAGER",
}

export const AccessRoleTypeAll: AccessRoleType[] = [
  AccessRoleType.ROLE_ADMIN,
  AccessRoleType.ROLE_MANAGER,
  AccessRoleType.ROLE_HR,
  AccessRoleType.ROLE_CONTRACTOR,
  AccessRoleType.ROLE_HIRING_MANAGER,
];
